import { render, staticRenderFns } from "./SiteDescription.vue?vue&type=template&id=70fb8d49&scoped=true&"
import script from "./SiteDescription.vue?vue&type=script&lang=js&"
export * from "./SiteDescription.vue?vue&type=script&lang=js&"
import style0 from "./SiteDescription.vue?vue&type=style&index=0&id=70fb8d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb8d49",
  null
  
)

export default component.exports